import clsx from 'clsx';

import type { CSSProperties, PropsWithChildren } from 'react';

import { Column } from './Column';
import styles from './GridRow.module.css';

type spacing = '0' | '025' | '050' | '075' | '100' | '125' | '150' | '175' | '200' | '250' | '300' | '350';
export interface GridRowProps {
  /** The horizontal padding between columns. */
  gutter?: spacing;
  /** The vertical padding (at the bottom) between rows. */
  marginBottom?: spacing;
  /** The vertical padding (at the top) between rows. */
  marginTop?: spacing;
}

const gapStyles = {
  '0': { '--grid-gap': '0.25rem' },
  '025': { '--grid-gap': '0.25rem' },
  '050': { '--grid-gap': '0.5rem' },
  '075': { '--grid-gap': '0.75rem' },
  '100': { '--grid-gap': '1rem' },
  '125': { '--grid-gap': '1.25rem' },
  '150': { '--grid-gap': '1.5rem' },
  '175': { '--grid-gap': '1.75rem' },
  '200': { '--grid-gap': '2rem' },
  '250': { '--grid-gap': '2.5rem' },
  '300': { '--grid-gap': '3rem' },
  '350': { '--grid-gap': '3.5rem' },
};

/** Represents a component for a grid. */
export const GridRow = ({
  gutter = '200',
  marginBottom = '0',
  marginTop = '0',
  children,
}: PropsWithChildren<GridRowProps>) => {
  return (
    <div
      className={clsx(
        styles['page-grid__row'],
        marginBottom && styles[`page-grid__row-mb-${marginBottom}`],
        marginTop && styles[`page-grid__row-mt-${marginTop}`]
      )}
      style={gutter && (gapStyles[gutter] as CSSProperties)}
    >
      {children}
    </div>
  );
};

GridRow.Column = Column;
